import { useEffect,useState  } from 'react'
import AOS from 'aos'
import Button from '@ui/Button'
import MetaInfo from '@/components/common/MetaInfo'
import Breadcrumb from '@common/Breadcrumb'
import TransformBanner from '@sections/TransformBanner'
import { ROUTES,SITE } from '@/constants'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.STAFF_AUGMENTATION)


// Section A — why dedicated developers
const WHY_DEDICATED_DEVS = [
  { icon: 'fa-gauge-high',    title: 'Scale Your Team Faster',            desc: 'Add experienced developers to your team without lengthy hiring cycles or the complexities of permanent recruitment.' },
  { icon: 'fa-user-graduate', title: 'Access Specialized Expertise',      desc: 'Bring in developers with expertise across modern web, mobile, cloud, AI, data, and enterprise technologies.' },
  { icon: 'fa-people-group',  title: 'Work as an Extension of Your Team', desc: 'Our developers collaborate closely with your in-house teams, product managers, designers, and technical leadership.' },
  { icon: 'fa-sliders',       title: 'Flexible Engagement Models',        desc: 'Scale resources up or down as your project requirements change, giving you greater control over technology costs and delivery capacity.' },
  { icon: 'fa-bolt',          title: 'Accelerate Product Development',    desc: 'Increase engineering capacity and move projects from development to deployment faster.' },
]

// Section B — technology stacks
const TECH_STACKS = [
  { icon: 'fa-display',               title: 'Frontend & Web Development', desc: 'Modern web applications, responsive interfaces, enterprise portals, and customer-facing platforms.' },
  { icon: 'fa-server',                title: 'Backend Development',        desc: 'Scalable APIs, business logic, integrations, microservices, and enterprise application development.' },
  { icon: 'fa-mobile-screen-button',  title: 'Mobile Development',         desc: 'Native and cross-platform mobile applications for Android and iOS.' },
  { icon: 'fa-cloud',                 title: 'Cloud & DevOps',             desc: 'Cloud-native development, infrastructure automation, CI/CD, deployment, monitoring, and application modernization.' },
  { icon: 'fa-brain',                 title: 'AI & Data Engineering',      desc: 'AI-powered applications, machine learning solutions, data pipelines, LLM applications, and intelligent automation.' },
  { icon: 'fa-vial',                  title: 'QA & Test Engineering',      desc: 'Manual and automated testing, API testing, performance testing, and quality engineering.' },
]

// Section D — engagement models
const ENGAGEMENT_MODELS = [
  { icon: 'fa-user',             title: 'Individual Developers',         desc: 'Add specific technical expertise to your existing engineering team for a defined project or ongoing requirement.' },
  { icon: 'fa-users',            title: 'Extended Development Team',     desc: 'Build a dedicated team of developers that works alongside your internal technology organization.' },
  { icon: 'fa-diagram-project',  title: 'Dedicated Product Team',        desc: 'Bring together developers, QA engineers, designers, and other specialists to support end-to-end product development.' },
  { icon: 'fa-shield-halved',    title: 'Long-Term Engineering Support', desc: 'Maintain a dedicated technology team for continuous development, enhancement, modernization, and application support.' },
  
]

// Section E — why CruxBytes
// Section E — why CruxBytes
const WHY_CRUXBYTES = [
  { icon: 'fa-user-tie',      title: 'Experienced Technology Professionals', desc: 'Work with developers who understand real-world application development, enterprise requirements, and evolving technology environments.' },
  { icon: 'fa-puzzle-piece',  title: 'Seamless Team Integration',            desc: 'Our developers adapt to your workflows, communication practices, tools, and development processes.' },
  { icon: 'fa-handshake',     title: 'Transparent & Flexible Engagements',   desc: 'Choose a model that fits your project scope, technical requirements, and business priorities.' },
  { icon: 'fa-stopwatch',     title: 'Faster Access to Talent',              desc: 'Expand your technology capabilities without depending entirely on lengthy internal recruitment processes.' },
  { icon: 'fa-infinity',      title: 'Technology Ownership & Continuity',    desc: 'Build long-term development partnerships with teams that understand your product, technology, and business objectives.' },
]



export default function HireDedicatedDevelopers() {
 
  //useEffect(() => { AOS.refresh(); window.scrollTo(0, 0) }, [])
useEffect(() => {
  AOS.refresh()
  window.scrollTo(0, 0)

  function initTree(dotId, branchIds, startX) {
    const dot = document.getElementById(dotId)
    if (!dot) return

    let currentBranch = 0
    let startTime = null

    const duration = 1200
    const pauseTime = 400

    function animateDot(timestamp) {
      if (!startTime) startTime = timestamp

      const elapsed = timestamp - startTime
      const path = document.getElementById(branchIds[currentBranch])

      if (!path) return

      const totalLen = path.getTotalLength()

      if (elapsed < duration) {
        let progress = elapsed / duration

        // ease-in / ease-out
        progress =
          progress < 0.5
            ? 2 * progress * progress
            : -1 + (4 - 2 * progress) * progress

        const point = path.getPointAtLength(progress * totalLen)

        dot.setAttribute('cx', point.x)
        dot.setAttribute('cy', point.y)

        requestAnimationFrame(animateDot)
      } else {
        const endPoint = path.getPointAtLength(totalLen)

        dot.setAttribute('cx', endPoint.x)
        dot.setAttribute('cy', endPoint.y)

        setTimeout(() => {
          // Reset to root
          dot.setAttribute('cx', startX)
          dot.setAttribute('cy', 0)

          // Next branch
          currentBranch =
            (currentBranch + 1) % branchIds.length

          startTime = null

          requestAnimationFrame(animateDot)
        }, pauseTime)
      }
    }

    setTimeout(() => {
      requestAnimationFrame(animateDot)
    }, 500)
  }

  initTree(
    'travel-dot-ux',
    [
      'ux-branch-1',
      'ux-branch-2',
      'ux-branch-3',
      'ux-branch-4',
    ],
    600
  )
}, [])
  return (
    <>
      {/* <MetaInfo
        title="Hire Dedicated Developers | CruxBytes"
        description="Hire dedicated developers who work as an extension of your team — flexible engagement models across web, mobile, cloud, AI, and QA engineering."
        keywords="Hire dedicated developers, team augmentation, dedicated development team, staff augmentation company, extended engineering team"
      /> */}
       <MetaInfo
     title={label}
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
        <div className="page-hero">
          <div className="bg-grid bg-grid--fill" aria-hidden="true" />
          <div className="container">
            <Breadcrumb />
            <h1 data-aos="fade-up" data-aos-delay={100}>              
              {/* Hire Dedicated Developers */}
              {label}
              </h1>
            <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
              {/* Extend your team with skilled developers who integrate seamlessly. */}
              {pageDesc}
            </p>

            <div className="inner-page-actions">
              <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                Get a Free Quote
              </Button>
            </div>
          </div>
        </div>

       {/* section 1 */}
        <section className="bg-peach section-py text-center" >
      <div className="container">
        
         <p data-aos="fade-up">
             Build and scale your engineering capabilities with dedicated developers who work as an extension of your existing team. Our developers can collaborate with your internal teams, follow your processes, and work within your preferred technology stack and development methodology. This allows you to accelerate delivery without the overhead of expanding your permanent workforce.
          </p>
         <p data-aos="fade-up" data-aos-delay={100}> Every organization has different technology requirements. Our dedicated developer model gives you the flexibility to scale your team based on project scope, timelines, and business priorities.
          </p>
                  <div className="deliverables-card mt-4">
          <ul className="deliverables-grid deliverables-grid--centered">
            {WHY_DEDICATED_DEVS.map((item, i) => (
              <li
                key={item.title}
                className="deliverable-item"
                data-aos="fade-up"
                data-aos-delay={(i % 3) * 70}
              >
                <h3 className="deliverable-title">{item.title}</h3>
                <p className="deliverable-desc">{item.desc}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
    {/* section 2 */}
     <section className="section-py" >
      <div className="container">
         <div className="text-align-center" data-aos="fade-up">              
              <h2 >Developers Across Modern Technology Stacks</h2>
            </div>
            <p className='text-center' data-aos="fade-up" data-aos-delay={100}>
              Our engineering teams can support a wide range of technology requirements, including:
            </p>
     <ul className="deliverables-grid--centered flip-grid">
          {TECH_STACKS.map((item, i) => (
            <li
              key={item.title}
              className="flip-card"
              tabIndex={0}
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 100}
            >
              <div className="flip-card__inner">
                <div className="flip-card__face">
                  {/* <span  aria-hidden="true">
                    <i className={`fa-solid ${item.icon}`} />
                  </span> */}
                  <p className="flip-card__title">{item.title}</p>
                </div>
                <div className="flip-card__face flip-card__face--back">
                  {/* <span  aria-hidden="true">
                    <i className={`fa-solid ${item.icon}`} />
                  </span> */}
                  <p className="flip-card__desc">{item.desc}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
     
 <div className="technology-stacks-cta">
      <span className="text-highlight" data-aos="fade-up">
        Tell us what you need, and we’ll help you build the right team.
      </span>

      <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right"  iconPos="right"   data-aos="fade-right">
        Build Your Team
      </Button>
    </div>
      </div>
    </section>
     {/* section 3 */}
     <section className="section-py bg-linear-gradient-light" >
      <div className="container">
         <div className="text-align-center" data-aos="fade-up">              
              <h2 >Choose the Engagement That Fits Your Needs</h2>
            </div>
            <p className='text-center' data-aos="fade-up" data-aos-delay={100}>
              Whether you need one developer to strengthen an existing team or a dedicated multidisciplinary team to take ownership of a complete product, we can structure an engagement around your requirements.
            </p>

             <div className="policy-tree-section">
                    <div className="text-center">
                      <span className="policy-root" id="policy-root-node" data-aos="fade-up">
                        Engagement Models
                      </span>
                    </div>

                    <div className="policy-tree-connector" data-aos="fade-up" data-aos-delay={100}>
                    <svg
                      id="policy-tree-svg"
                      viewBox="0 0 1200 140"
                      preserveAspectRatio="xMidYMid meet"
                      aria-hidden="true"
                    >
                      <path
                        id="ux-branch-1"
                        className="branch-line"
                        d="M 600,0 L 600,45 Q 600,70 550,70 L 150,70 Q 130,70 130,95 L 130,140"
                      />

                      <path
                        id="ux-branch-2"
                        className="branch-line"
                        d="M 600,0 L 600,45 Q 600,70 570,70 L 400,70 Q 380,70 380,95 L 380,140"
                      />

                      <path
                        id="ux-branch-3"
                        className="branch-line"
                        d="M 600,0 L 600,45 Q 600,70 630,70 L 800,70 Q 820,70 820,95 L 820,140"
                      />

                      <path
                        id="ux-branch-4"
                        className="branch-line"
                        d="M 600,0 L 600,45 Q 600,70 650,70 L 1050,70 Q 1070,70 1070,95 L 1070,140"
                      />

                      <circle
                        className="travel-dot"
                        id="travel-dot-ux"
                        cx="600"
                        cy="0"
                        r="5"
                      />
                    </svg>
                  </div>

                    <div className="policy-cards-row policy-cards-row--four" >
                    {ENGAGEMENT_MODELS.map((step, i) => (
                    <div className="policy-card" key={step.title} data-aos="fade-up" data-aos-delay={i * 100}>
                      
                      <span className="sc-bullet-icon" aria-hidden="true">
                        <i className={`fa-solid ${step.icon}`} />
                      </span>
                      <span >{step.title}</span>
                      <span className='hire-desc'>{step.desc}</span>
                    </div>
                  ))}
                    </div>
                  </div>

      </div>
    </section>
     {/* section 4 */}
        {/* section 4 */}
       <section className="section-py" aria-labelledby="pux-outcomes-heading">
  <div className="container">
    <div className="sc-ai-row sc-tm-row--sticky-heading">

      <div className="sc-tm-content" data-aos="fade-left">
         {/* <h2 id="pux-outcomes-heading" >
        Business Benefits of Software Consulting
        </h2> */}
     <h2 id="impact-heading" >
            <span className="impact-heading-dark">Why Choose CruxBytes</span>
            <span className="impact-heading-light">for Team Augmentation?</span>
          </h2>
      </div>
<div className="why-team-augmentation" data-aos="fade-right">
  {WHY_CRUXBYTES.map((card, i) => (
    <div
      key={card.title}
      className="why-team-augmentation-item"
      data-aos="fade-up"
      data-aos-delay={(i % 3) * 80}
    >
      <div className="why-team-augmentation-icon">
        <i className={`fa-solid ${card.icon}`} />
      </div>

      <div className="why-team-augmentation-content">
        <h3 className="why-team-augmentation-title">
          {card.title}
        </h3>

        <p className="why-team-augmentation-desc">
          {card.desc}
        </p>
      </div>
    </div>
  ))}
</div>  

    </div>
  </div>
</section>

        <TransformBanner />
      </main>
    </>
  )
}